<template>
  <div class="zcbody" v-loading="loading">
    <div class="contanerpric minprict">
      <!-- 
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix clearheader">
          <b>预中标描述</b>
          <div class="pull-right">
          </div>
        </div>
        <table cellspacing="0" cellpadding="0" class="Projectdetails">

          <tr>
            <td colspan="8">
              <el-input v-model="dt.cdescribe" type="textarea" rows="5" placeholder="请输入内容"></el-input>
            </td>

          </tr>
          <tr>
            <td colspan="8" style="text-align:right">
              <el-button type="primary" size="mini" @click="SetInquiryAward()">保存预中标描述</el-button>
            </td>

          </tr>
        </table>
      </el-card> -->
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <i class="el-icon-s-unfold"></i><b>开标一览表</b>
        </div>
        <!-- <div class="text item text-center">
          <div class="pull-right" style="margin-bottom:15px">
            <el-button type="primary" size="medium" @click="daochu()">导出</el-button>
            <el-button type="warning" size="medium">分标段授标</el-button>
            <el-button type="warning" size="medium">投标</el-button>
            <el-button type="primary" size="medium">预中标描述</el-button>
            <el-button type="info" size="medium">OA签批</el-button>
          </div>
        </div> -->
        <tablerends
          ref="rendsref"
          :dt="dt"
          :dt2list1="dt2list1"
          @rend="rend"
          :dt2list="dt2list"
          :dt2table1="tablelist0"
          :cop="cop"
          :tableHead="tableHead"
          :urlid="urlid"
        />
        <!-- 可以使用span 和 span-map对象来控制栅格的大小 -->
      </el-card>
      <zpin :dt3="dt3" :dt4="dt4" :dt5="dt5" />
    </div>
  </div>
</template>

<script>
// import { set } from "vue/types/umd";
import tablerends from "./tabletrends.vue";
import zpin from "./zpin.vue";
export default {
  components: {
    tablerends,
    zpin,
  },
  data () {
    return {
      dt: {},
      dt2: {},
      dt3: [],
      dt4: [],
      dt5: [],
      dt2list1: [],
      dt2list: [],
      urlid: "",
      cop: "",
      loading: false,
      tableHead: [],
      tablelist0: [],
    };
  },
  created () {
    this.urlid = this.$route.query.id;
    this.cop = this.$route.query.cop;
    if (this.urlid != "") {
      this.GetLogInfoByCode();
    }
  },
  methods: {
    // 监听授标完成
    rend (val) {
      this.GetLogInfoByCode();
    },
    // 获取基本信息
    GetLogInfoByCode () {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetLogInfoByCode",
        data: { clogincode: this.cop },
      }).then((res) => {
        console.log(res);

        if (res.data.Success) {
          this.GetInquiryAllInfo();
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },

    // 返回
    returnpage () {
      sessionStorage.removeItem("params");
      this.$router.push({ path: "/pricinglist?cop=" + this.cop });
    },
    // 获取详情
    GetInquiryAllInfo () {
      this.loading = true;
      this.dt = {};
      this.dt2 = [];
      this.dt3 = [];
      this.dt2list1 = [];
      this.dt2list = [];
      this.dt4 = [];
      this.dt5 = [];
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetInquiryAllInfo",
        data: { KeyValue: this.urlid },
      })
        .then((res) => {
          this.loading = false;
          console.log(res, "结果");
          setTimeout(() => {
            if (res.data.Success) {
              this.loading = false;
              this.dt = res.data.Data.dt[0];
              this.dt2 = res.data.Data.dt2;
              this.dt3 = res.data.Data.dt3;
              this.dt2list1 = res.data.Data.dt2.Table1;
              this.dt2list = res.data.Data.dt2.Table;
              this.dt4 = res.data.Data.dt4;
              this.dt5 = res.data.Data.dt5;
              this.arryzli();
            } else {
              this.loading = false;
              this.$message.error(res.data.Message);
            }
          }, 10);
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    arryzli () {
      const res = new Map();
      console.log(this.dt2.Table1);
      this.tableHead = [];
      var tablelist1 = this.dt2.Table1.filter(
        (arr) => !res.has(arr.cvenname) && res.set(arr.cvenname, 1)
      );
      // console.log(tablelist1);
      // var tablehead = [];

      for (var a = 0; a < tablelist1.length; a++) {
        this.tableHead.push({
          label: tablelist1[a].cvenname,
          property: "cvename" + tablelist1[a].cvencode,
          child: [],
        });
      }
      // console.log(this.tableHead);
      var tablelist = this.dt2.Table1;
      var tablelist0 = this.dt2.Table;
      for (var b = 0; b < tablelist.length; b++) {
        tablelist0.forEach((tablistnew) => {
          if (tablelist[b].iautoid == tablistnew.iautoid) {
            this.$set(
              tablistnew,
              "cvename" + tablelist[b].cvencode,
              tablelist[b].iprice
            );
            tablistnew = Object.assign(tablistnew, tablelist[b]);
          }
        });
      }

      this.tablelist0 = tablelist0.filter(
        (arrdt2) => !res.has(arrdt2.iautoid) && res.set(arrdt2.iautoid, 1)
      );
    },
    // 去重
    unique (arr) {
      const res = new Map();
      return arr.filter(
        (arr) => !res.has(arr.cclasscode) && res.set(arr.cclasscode, 1)
      );
    },
  },
};
</script>

<style scoped>
@import url(../../assets/css/reg.css);
</style>

